import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import { ConfigSelectors } from '@wix/da-shared-react/pkg/config';

export function* apiGet(endpoint: string, params?: any) {
  const csrfToken = yield select(ConfigSelectors.key('csrfToken'));
  const result = yield call(apiGetAsync, endpoint, {
    ...params,
    csrf_token: csrfToken,
  });
  return result;
}

async function apiGetAsync<TResponse>(endpoint: string, params?: any) {
  try {
    const { data } = await axios.get<TResponse>(`api${endpoint}`, { params });
    return data;
  } catch {
    return false;
  }
}

async function apiPostAsync<TResponse>(endpoint: string, params?: any) {
  try {
    const { data } = await axios.post<TResponse>(`api${endpoint}`, params);
    return data;
  } catch {
    return false;
  }
}

export function* apiPost(endpoint: string, params: any = {}) {
  const csrfToken = yield select(ConfigSelectors.key('csrfToken'));
  const result = yield call(apiPostAsync, endpoint, {
    ...params,
    csrf_token: csrfToken,
  });
  return result;
}
